import { useEffect } from 'react';

const MetaTags = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  author = 'SBX Trade',
  locale = 'pt_BR',
  siteName = 'SBX Trade',
  noIndex = false
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, property = null) => {
      if (!content) return;
      
      const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
      let metaTag = document.querySelector(selector);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        if (property) {
          metaTag.setAttribute('property', property);
        } else {
          metaTag.setAttribute('name', name);
        }
        document.head.appendChild(metaTag);
      }
      
      metaTag.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);
    updateMetaTag('robots', noIndex ? 'noindex,nofollow' : 'index,follow');

    // Open Graph meta tags
    updateMetaTag(null, title, 'og:title');
    updateMetaTag(null, description, 'og:description');
    updateMetaTag(null, image, 'og:image');
    updateMetaTag(null, url, 'og:url');
    updateMetaTag(null, type, 'og:type');
    updateMetaTag(null, siteName, 'og:site_name');
    updateMetaTag(null, locale, 'og:locale');

    // Twitter Card meta tags
    updateMetaTag(null, 'summary_large_image', 'twitter:card');
    updateMetaTag(null, title, 'twitter:title');
    updateMetaTag(null, description, 'twitter:description');
    updateMetaTag(null, image, 'twitter:image');
    updateMetaTag(null, '@sbxtrade', 'twitter:site');

    // Canonical URL
    if (url) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', url);
    }

    // Cleanup function to remove dynamically added meta tags
    return () => {
      // Remove dynamic meta tags when component unmounts
      const dynamicSelectors = [
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[property="og:image"]',
        'meta[property="og:url"]',
        'meta[property="og:type"]',
        'meta[property="og:site_name"]',
        'meta[property="og:locale"]',
        'meta[name="twitter:card"]',
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]',
        'meta[name="twitter:image"]',
        'meta[name="twitter:site"]',
        'link[rel="canonical"]'
      ];

      dynamicSelectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });
    };
  }, [title, description, keywords, image, url, type, author, locale, siteName, noIndex]);

  return null; // This component doesn't render anything visible
};

export default MetaTags;